/* @flow */
import { buildGoogleCalendarUrl } from 'lib/createGoogleCalLink';
import React from 'react';
import Activity from 'entities/Activity';
import Link from 'components/Link.jsx';
import Money from 'payments/components/Money.jsx';
import Text from 'components/Text.jsx';
import TimeRange from 'components/TimeRange.jsx';

import './styles/PaymentViewSideInformation.scss';

type Props = {
  activity: Activity,
};

class PaymentViewSideInformation extends React.Component {
  props: Props;

  renderGoogleCalUrl() {
    const { activity } = this.props;
    const date = activity.getStartAt();
    const title = activity.getTitle();
    const welcomeMsgBody = activity.getWelcomeMsgBody();
    const location = activity.getLocation();
    const googleCalendarUrl = date ? buildGoogleCalendarUrl(title, date, welcomeMsgBody, location) : null;

    return googleCalendarUrl ?
    (
      <div className="PaymentViewSideInformation-item-content">
        <Link target="_blank" href={googleCalendarUrl}>
          <Text size="xsmall" weight="semibold">
            Add to Google Calendar
          </Text>
        </Link>
      </div>
    ) : (
    <span />
    );
  }

  render() {
    const startAt = this.props.activity.getStartAt();
    const endAt = this.props.activity.getEndAt();
    const amountPerPerson = this.props.activity.getAmountPerPerson();

    return (
      <div className="PaymentViewSideInformation">
        <div className="PaymentViewSideInformation-title">
          Activity details
        </div>

        <div>
          <Text color="thunder">
            {this.props.activity.getWelcomeMsgBody()}
          </Text>
        </div>

        {this.props.activity.getLocation() &&
          <div className="PaymentViewSideInformation-item">
            <div className="PaymentViewSideInformation-item-header">
              <strong>Where:</strong>
            </div>
            <div className="PaymentViewSideInformation-item-content">
              {this.props.activity.getLocation()}
            </div>
          </div>
        }

        {this.props.activity.getStartAt() &&
          <div className="PaymentViewSideInformation-item">
            <div className="PaymentViewSideInformation-item-header">
              <strong>When:</strong>
            </div>
            <div className="PaymentViewSideInformation-item-content">
              {startAt &&
                <TimeRange
                  start={startAt}
                  end={endAt}
                  month="long"
                  year="numeric"
                  day="2-digit"
                  hour="2-digit"
                  minute="2-digit"
                />
              }
            </div>
            {this.renderGoogleCalUrl()}
          </div>
        }

        <div className="PaymentViewSideInformation-item">
          <div className="PaymentViewSideInformation-item-header">
            <strong>Cost:</strong>
          </div>
          <div className="PaymentViewSideInformation-item-content">
            {amountPerPerson && amountPerPerson > 0 ?
              <Money cents={this.props.activity.getAmountPerPerson()} /> :
              <span>Free</span>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentViewSideInformation;



// WEBPACK FOOTER //
// ./src/payments/components/PaymentViewSideInformation.jsx